import { appendGtmLoaderWithCookiebotConsentBridge } from 'app-core'
import { GTM_ID, GTM_QUERY_TAIL } from './consts'

const gtmLoaderOptions = {
  gtmId: GTM_ID,
  gtmQueryTail: GTM_QUERY_TAIL,
  pushDataLayerLoadedEvent: false as const,
}

export const bootstrapDevicesAnalyticsAfterHydration = (): void => {
  if (typeof document === 'undefined') return

  appendGtmLoaderWithCookiebotConsentBridge(gtmLoaderOptions)
}
